import { Grid } from "@mui/material";
import Broucher from "Pages/components/Broucher";
import Box from "ReusableComponents/Box";
import Button from "ReusableComponents/Button";
import Text from "ReusableComponents/Text";
import { apiClient } from "api/apiClient";
import Download from "assets/download.svg";
import Phone from "assets/phone.svg";
import PhoneWhite from "assets/phoneWhite.png";
import { useEffect, useState } from "react";
import { COLORS, SIZES } from "theme";

import H2 from "ReusableComponents/Text/H2";
import Span from "ReusableComponents/Text/Span";
import { useTranslation } from "react-i18next";

const ContactSection = ({ small, medium }) => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  const [title, setTitle] = useState();

  const [hover, setHover] = useState(false);
  const [hover1, setHover1] = useState(false);
  useEffect(() => {
    apiClient.getContactSectionTitle().then((res) => {
      setTitle(res?.data.attributes.title);
    });
  }, []);
  return (
    <Grid
      container
      spacing={2}
      alignItems="center"
      sx={
        small
          ? { padding: SIZES.forty }
          : {
              paddingTop: "50px",
              paddingLeft: "80px",
              paddingRight: "80px",
              paddingBottom: "50px",
            }
      }
    >
      <Grid item xs={12} md={6}>
        <Box display="flex" flexDirection="column">
          <H2
            fontSize={small ? SIZES.twenty : "48px"}
            fontWeight={"bolder"}
            margin={0}
            display="flex"
            flexDirection="column"
          >
            <Span
              fontSize={small ? SIZES.fourteen : SIZES.twenty}
              w="fit-content"
              textAlign={small ? "center" : "left"}
              textColor={COLORS.white}
              fontWeight="bold"
            >
              {title}
            </Span>
          </H2>
        </Box>
      </Grid>

      <Grid item xs={12} md={6}>
        <Box
          display="flex"
          flexDirection={small ? "column" : "row"}
          alignItems="center"
          justifyContent={small ? "center" : "flex-end"}
          flexWrap="wrap"
        >
          <a href="tel:1800 1238 1238">
            <Box
              border={COLORS.primary}
              display="flex"
              cursor="pointer"
              w={small || medium ? "100%" : "250px"}
              justifyContent="center"
              marginTop="22px"
              alignItems="center"
              b="1px solid #99CEFB"
              onMouseEnter={() => setHover1(true)}
              hoverBackground={true}
              onMouseLeave={() => setHover1(false)}
              backgroundColor={hover1 ? COLORS.primary : COLORS.white}
              padding={"0 20px"}
            >
              <img
                src={hover1 ? Phone : PhoneWhite}
                alt="phone"
                style={{ margin: "0 8px" }}
                height={"21px"}
              />

              <Text
                fontWeight="bold"
                fontSize="15px"
                textColor={hover1 ? COLORS.black : COLORS.primary}
              >
                {t("Call Us 1800 1238 1238")}
              </Text>
            </Box>
          </a>
          <Button
            isHover={true}
            display="flex"
            cursor="pointer"
            w={small || medium ? "74%" : "250px"}
            justifyContent="center"
            marginLeft={small ? "0" : "20px"}
            marginTop={small ? "20px" : SIZES.twenty}
            alignItems="center"
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            background={hover ? COLORS.black : COLORS.primary}
            onClick={() => setOpen(true)}
            padding={small ? "13px 0px" : "15px"}
          >
            <img
              src={Download}
              alt="download"
              style={{ margin: "0 8px" }}
              height={"21px"}
            />
            <Text
              fontWeight="bold"
              fontSize="15px"
              textColor={hover ? COLORS.white : COLORS.black}
              margin={"0 8px"}
            >
              {t("Download Brochure")}
            </Text>
          </Button>
        </Box>
      </Grid>

      {open && (
        <Broucher
          open={open}
          handleClose={() => setOpen(false)}
          small={small}
        />
      )}
    </Grid>
  );
};

export default ContactSection;
